import SessionEventTypeModal from './SessionEventTypeModal';

export default SessionEventTypeModal;
